/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { isSodimacRetail } from '@digital-retail/store-manager';
import apiConfig from '../../config/api/apiConfig';
import constants from '../../config/constants';
import { CookieStorage } from '../CookieStorage';
import { httpService } from '../httpService';

const useUserSegments = (regionCode, userSegments, isUserLoggedIn, store) => {
  const [currentUserSegments, setCurrentUserSegments] = useState([]);

  const getUserSegmentsFromCookie = () => {
    const userSegmentValue = CookieStorage.getCookie(constants.USER_SEGMENTS);
    const userSegmentDecode = CookieStorage.parseCookieValue(constants.USER_SEGMENTS, userSegmentValue);
    return userSegmentDecode || [];
  };

  const setUserSegmentsToCookie = (newUserSegments) => {
    CookieStorage.setCookie({
      name: constants.USER_SEGMENTS,
      value: Buffer.from(JSON.stringify(newUserSegments)).toString('base64'),
      regionCode,
      expiryDays: 1,
      store,
    });
  };

  const getAccountOptions = () => {
    if (isSodimacRetail(store)) {
      return {
        accountPath: 'myaccount',
        commerceName: `sodimac-${regionCode}`,
      };
    }
    return {
      accountPath: 'account',
      commerceName: `marketplace-${regionCode}`,
    };
  };
  const fetchUserSegments = async () => {
    const baseUrl = apiConfig.getUserSessionInfo(regionCode, '');
    const userId = CookieStorage.getCookie('USER_ID') || '';
    const sId = CookieStorage.getCookie('sid');
    const { accountPath, commerceName } = getAccountOptions();
    const segmentsUrl = `${baseUrl}/s/${accountPath}/v2/user/${userId}/segments`;

    if (!userId && !sId) {
      return;
    }

    const { error, data } = await httpService().get(segmentsUrl, {
      includeTracing: false,
      headers: {
        'x-channel-id': 'WEB',
        'x-ecomm-name': commerceName,
        Authorization: sId,
      },
    });

    if (error) {
      throw new Error('Error getting the last user segments');
    }

    if (data && data.data && data.data.user) {
      const { segments } = data.data.user;
      setUserSegmentsToCookie(segments);
      setCurrentUserSegments(segments);
    }
  };

  useEffect(() => {
    if (isUserLoggedIn) {
      if (!userSegments?.length) {
        const segmentsFromCookie = getUserSegmentsFromCookie();
        if (segmentsFromCookie?.length) {
          setCurrentUserSegments(segmentsFromCookie);
        } else {
          fetchUserSegments();
        }
      } else {
        setCurrentUserSegments(userSegments);
      }
    }
  }, [isUserLoggedIn]);

  return { currentUserSegments };
};

export { useUserSegments };
